export default __webpack_public_path__ + "static/media/wordpress-logo.9b476bf7.svg";